import axios from 'axios';
import swal from "sweetalert";
import GlobalConfigs from "../configs/GlobalConfigs";
import * as Apis from '../apis/Apis';

export function getContentValidator(page, name, email,phoneno) {

    let getData = localStorage.getItem('userDetails');
    let token = JSON.parse(getData).token;
    const postData = {
        page,
        name,
        email,
        phoneno
    };
    return axios({
        url: GlobalConfigs.API_URL + Apis.GET_CONTENT_VALIDATOR_LIST_API,
        method: "POST",
        headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${token}`
        },
        data: postData,
    });

}

export function updateContentValidator(id, name, email, phone) {

    let getData = localStorage.getItem('userDetails');
    let token = JSON.parse(getData).token;

    const postData = {
        id,
        name,
        email,
        phone
    };

    return axios({
        url: GlobalConfigs.API_URL + Apis.UPDATE_CONTENT_VALIDATOR_API,
        method: "POST",
        headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${token}`
        },
        data: postData,
    });

}

export function editContentValidatorStatus(id, status) {

    let getData = localStorage.getItem('userDetails');
    let token = JSON.parse(getData).token;

    const postData = {
        id,
        status
    };

    return axios({
        url: GlobalConfigs.API_URL + Apis.UPDATE_CONTENT_VALIDATOR_STATUS_API,
        method: "POST",
        headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${token}`
        },
        data: postData,
    });

}

export function removeContentValidator(id) {

    let getData = localStorage.getItem('userDetails');
    let token = JSON.parse(getData).token;

    const postData = {
        id
    };
    return axios({
        url: GlobalConfigs.API_URL + Apis.REMOVE_CONTENT_VALIDATOR_LIST_API,
        method: "DELETE",
        headers: {
            ContentType: "application/json",
            Authorization: `Bearer ${token}`
        },
        data: postData,
    });

}

